import React, { createContext, useContext } from 'react';

// What the tree being drawn needs to know about the builder's selection, and the only thing it needs to
// know: which node is selected. `InteractiveElementProps.activeChildId` is documented as the raw selection
// at any depth — each of the thirteen elements opens whichever of its own direct children holds that id in
// its subtree — so nothing here works out an ancestor path, and a shopper's page reads a context that is
// never provided and always answers null.

const SelectedElement = createContext<string | null>(null);

type ElementSelectionProviderProps = {
  /** The node the builder currently has selected, or null when it has nothing. */
  id: string | null;
  children: React.ReactNode;
};

/** Publishes the selection to the page being drawn, so the panel that hides it can open itself. */
export const ElementSelectionProvider: React.FC<ElementSelectionProviderProps> = ({ id, children }) => (
  <SelectedElement.Provider value={id}>{children}</SelectedElement.Provider>
);

// Names the node the builder has selected anywhere in the page, which is what an interactive element opens on.
export const useActiveChildId = (): string | undefined => useContext(SelectedElement) ?? undefined;
